// import {API_ROOT} from '@/config/env.js'
const ROOT = 'https://yianivd.com';

/**
 * 全局接口请求根域名
 */
export const API_ROOT = ROOT;

/**
 * 全局资源根路径
 */
export const ASSETS_ROOT = ROOT + '/mpassets/';

/**
 * 运行环境 是否为小程序环境
 */
// #ifdef MP
export const IS_ENV_MP = 1;
// #endif
// #ifndef MP
export const IS_ENV_MP = 0;
// #endif

/**
 * 测试用户的 用户ID  token
 */
export const MOCK_USER_ID = '53';
export const MOCK_USER_TOKEN = '0fcf00a236';
// export const MOCK_USER_TOKEN = 'xx';


//微信审核版本 审核时不开启限制 审核通过后开启限制
//每次审核时 后台的版本号需要删除  通过后改为WEIXIN_AUDIT_VERSION 变量对应的版本号 如  1.0.1
export const WEIXIN_AUDIT_VERSION = '1.0.1';

export const USER_TYPE_MAP = {
	1: 'I类', //医院  I类、
	2: 'II类', //诊所 II类
	3: 'III类', //宠物医院  、III类
};

export const USER_TYPE_OPTIONS = [{
		title: 'I类',
		value: '1',
	},
	{
		title: 'II类',
		value: '2',
	},
	{
		title: 'III类',
		value: '3',
	},
];